import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CustomersRoutingModule } from './customers-routing.module';
import { ReportCustomersComponent } from './customers.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgxPaginationModule } from 'ngx-pagination';

@NgModule({
  declarations: [ReportCustomersComponent],
  imports: [
    CommonModule,NgxDatatableModule,
    NgxPaginationModule,
    CustomersRoutingModule
  ]
})
export class CustomersModule { }
